/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {activityPageThreadedFeed} from '../api'

 export const useQueryActivityPageThreadedFeed = createReactQueryHook('activityPageThreadedFeed', activityPageThreadedFeed)
